import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import {FlatList, SafeAreaView, View} from "react-native";
import React, {useContext, useRef, useState} from "react";
import Category from "../../../rest/jtmc/models/Category";
import {Product} from "../../../rest/jtmc/models/Product";
import ProductItem from "../components/ProductItem";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {useFocusEffect} from "@react-navigation/native";
import {OrderContext} from "../../../contexts/OrderContext";
import NoProductItem from "../components/NoProductItem";
import {MenuActionButtonStyles} from "../styles";
import {
    CartPageActionButton,
    GamesPageActionButton,
    ProfilePageActionButton,
    WaiterCallButton
} from "../components/MenuActionsComponents";
import MenuScreenFunction from "../../../components/screen-functions-components/MenuScreenFunction";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import SimpleSpinner from "../components/SimpleSpinner";

export default function Menu({navigation}: any) {
    const configContext = useContext(AppConfigContext);
    const appFunctions = useContext(AppFunctionsContext);
    const [menuDetails, setMenuDetails] = useState<MenuDetails>();

    useFocusEffect(React.useCallback(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    }, []));

    const [selectedCategoryId, setSelectedCategoryId] = useState(0);

    return <MenuScreenFunction onMenuDetailsChange={m => setMenuDetails(m)}>
        <SimpleSpinner
            selectedCategoryId={selectedCategoryId}
            menuDetails={menuDetails}
            onItemChange={(item: Category, index: number) => {
                setSelectedCategoryId(item.id);
            }}/>
        <ProductList
            menuDetails={menuDetails} selectedCategoryId={selectedCategoryId}/>
        <MenuActionsView
            menuDetails={menuDetails}/>
    </MenuScreenFunction>
}

function ProductList(props: any) {
    const menuDetails: MenuDetails = props.menuDetails;
    if (menuDetails == null)
        return <></>;

    const [productsToShow, setProductsToShow] = useState<Product[]>();
    menuDetails?.menuItems.forEach((item, index) => {
        if ((item.category?.id == props.selectedCategoryId) && (item.products != productsToShow))
            setProductsToShow(item.products);
    });
    const flatList = useRef().current;
    const hasProducts = (productsToShow?.length ?? 0) != 0;

    return hasProducts ?
        <SafeAreaView style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "visible",
            top: 0,
            bottom: 0,
            zIndex: -1
        }}>
            <FlatList ref={flatList}
                      showsVerticalScrollIndicator={false}
                      contentContainerStyle={{flexGrow: 1}}
                      style={{
                          marginTop: 20,
                          maxWidth: "100%",
                          paddingTop: 170,
                          paddingBottom: 80
                      }} data={productsToShow} renderItem={(item) => {
                return <ProductItem orderable={menuDetails.menuOptionsAccess.ordering} product={item.item}/>
            }}/>
        </SafeAreaView> : <View style={{marginTop: 20}}><NoProductItem/></View>
}

function MenuActionsView(props: any) {
    const menuDetails: MenuDetails = props.menuDetails;

    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instance(appConfigContext.theme, appConfigContext.color);
    const order = useContext(OrderContext);

    const lStyle = MenuActionButtonStyles(color);

    const actionButtonSet = [];

    switch (order.order?.type) {
        case "outside":
            actionButtonSet.push(<ProfilePageActionButton key={0} grow={25} color={"red"}/>);

            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={1} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={2} grow={25} color={"yellow"}/>);
            break;
        case "table":
            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={0} grow={25} color={"red"}/>);

            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={1} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.waiter_call)
                actionButtonSet.push(<WaiterCallButton key={2} grow={25} color={"yellow"}/>);
            break;
        case "takeaway":
            if (menuDetails?.menuOptionsAccess.ordering)
                actionButtonSet.push(<CartPageActionButton key={0} grow={50} menuDetails={menuDetails}/>);

            if (menuDetails?.menuOptionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={0} grow={50} color={"yellow"}/>);
            break;
    }

    return <View style={lStyle.buttonContainer}>
        {actionButtonSet}
    </View>
}